import { GDPRBanner } from '@wkda/gdpr-banner-react';
import React from 'react';
import { Helmet } from 'react-helmet';
import { ModalManager } from '../ModalManager';
import { useTrackLandingCallback } from '../hooks/tracking/useMarketingTrackingService';
import { useAppConfiguration, useCookieBannerQuery } from '../hooks/useDataHooks';
import { useGTM } from '../hooks/useGTM';
import { useModulesStore } from '../hooks/useModules';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function DefaultGDPRBanner(_ref) {
  let {
    APIService,
    cookieService,
    isProd,
    content,
    closeHandler,
    gtmService
  } = _ref;
  const trackLanding = useTrackLandingCallback();
  const {
    isPartnerFunnel
  } = useAppConfiguration();
  return /*#__PURE__*/_jsx(GDPRBanner, {
    APIService: APIService,
    cookieService: cookieService,
    isProd: isProd,
    content: content,
    closeHandler: closeHandler,
    ignorePreferencesCookie: false,
    onSubmit: () => {
      if (!isPartnerFunnel) {
        gtmService.update();
        trackLanding();
      }
    }
  });
}
function GDPRBannerContainer(_ref2) {
  let {
    customGDPRBanner: CustomGDPRBanner = DefaultGDPRBanner
  } = _ref2;
  const {
    gdprPreferencesModule
  } = useModulesStore();
  const {
    isPartnerFunnel
  } = useAppConfiguration();
  const {
    data: content,
    status
  } = useCookieBannerQuery();
  const [GTMScript, setGTMScript] = React.useState(null);
  const gtmService = useGTM({
    onStart: function (script) {
      if (!isPartnerFunnel) {
        setGTMScript(script);
      }
    }
  });
  return status === 'success' && content ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ModalManager.Modal, {
      type: ModalManager.types.MANDATORY,
      id: "gdpr-banner",
      children: _ref3 => {
        let {
          closeHandler
        } = _ref3;
        return /*#__PURE__*/_jsx(CustomGDPRBanner, {
          APIService: gdprPreferencesModule.APIService,
          cookieService: gdprPreferencesModule.cookieService,
          isProd: gdprPreferencesModule.isProd,
          content: content,
          closeHandler: closeHandler,
          gtmService: gtmService
        });
      }
    }), /*#__PURE__*/_jsx(Helmet, {
      children: GTMScript ? /*#__PURE__*/_jsx("script", {
        children: GTMScript
      }) : null
    })]
  }) : null;
}
export { GDPRBannerContainer as GDPRBanner };